module.exports = {
  ecommerce: {
    onekay_retailer: "com.onekay.retailer",
    otipy_partner: "com.otipy.partner",
    urbanclap_provider: "com.urbanclap.provider",
    jio_bapp: "com.jio.bapp",
  },
  loan: {
    lendenclub: "com.innofinsolutions.lendenclub.lender",
    twelve: "com.twelve.club",
    dhani: "com.dhani_app.dhani_finance.Dhani_loan",
    bajaj: "org.altruist.BajajExperia",
  },
};
